import { Tag } from 'antd'
import { observer } from 'mobx-react-lite'

import { EntityHeader, HeaderChip } from '@/Ship/Components/EntityCard'

import { ACTIVITY_OVERDUE_LABEL } from '../Contracts/ActivityFieldLabels'
import { describeActivityDeadline } from '../Helpers/activityDeadline'
import { isActivityCompleted, isActivityOverdue } from '../Helpers/activityOverdue'
import { ActivityOwnerLink, activityOwnerOf } from './ActivityOwnerLink'

import type { ActivityFormContextLike } from '../Contracts/Activity.types'

/**
 * Шапка справи (`SPEC-011` §8.4, К-2) — окремим observer-компонентом: вона
 * читає тип, термін і власника, які редагують, а ядровий `FormField` на кожне
 * перемальовування шаблону перемонтовує всі поля форми (`SPEC-002` §4.2).
 *
 *  - ліворуч — «Ід N», статус бейджем кольору довідника, «Прострочена»
 *    (предикат П) — словом, а не лише кольором (`SPEC-014` §1.5);
 *  - праворуч — чип терміну з тоном (`describeActivityDeadline`);
 *  - заголовок — тип справи, під ним — власник посиланням на його картку.
 */
export const ActivityCardHeader = observer(({ formContext }: { formContext: ActivityFormContextLike }) => {
    const values = formContext.values ?? {}
    const status = values.status
    const owner = activityOwnerOf(values)
    const deadline = describeActivityDeadline(values.deadline, isActivityCompleted(values))
    const title = typeof values.type?.title === 'string' && values.type.title !== '' ? values.type.title : undefined

    return (
        <EntityHeader
            {...(typeof values.id === 'number' ? { code: `Ід ${values.id}` } : {})}
            status={
                status && typeof status.title === 'string'
                    ? { label: status.title, ...(typeof status.color === 'string' ? { color: status.color } : {}) }
                    : undefined
            }
            {...(isActivityOverdue(values) ? { badges: <Tag color="error">{ACTIVITY_OVERDUE_LABEL}</Tag> } : {})}
            {...(deadline.text !== '—' ? { aside: <HeaderChip tone={deadline.tone}>{deadline.text}</HeaderChip> } : {})}
            {...(title !== undefined ? { title } : {})}
            {...(owner ? { subtitle: <ActivityOwnerLink kind={owner.kind} owner={owner.ref} /> } : {})}
        />
    )
})
